import React, { useState } from "react";
import api from "../services/api";
import { useTranslation } from 'react-i18next';
import { useEffect } from "react";

export default function EditDiscussionModal({ discussion, decryptedTitle, decryptedDescription, onClose, onUpdated }) {
const asText = (v) => (typeof v === 'string' ? v : '');
const initialTitle = decryptedTitle || asText(discussion.title);
const initialDescription = decryptedDescription || asText(discussion.description);
const [title, setTitle] = useState(initialTitle);
const [description, setDescription] = useState(initialDescription);

  //const [title, setTitle] = useState(decryptedTitle ?? '');
  //const [description, setDescription] = useState(decryptedDescription || "");
  const [theme, setTheme] = useState(discussion.theme);
const { t } = useTranslation();
const THEMES = [
  "actualite",
  "divertissement",
  "viequotidienne",
  "vieprofessionnelle"
];

const [allowComments, setAllowComments] = useState(discussion.allowComments);
const [visibility, setVisibility] = useState(discussion.visibility || 'everyone');
const [loading, setLoading] = useState(false);

useEffect(() => {
  setTitle(initialTitle);
  setDescription(initialDescription);
  setTheme(discussion.theme);
  setAllowComments(discussion.allowComments);
  setVisibility(discussion.visibility || 'everyone');
}, [discussion._id, initialTitle, initialDescription]); 

  const API_URL = process.env.REACT_APP_API_URL;
const token = localStorage.getItem('token') || "";

  const handleSave = async (e) => {
e.preventDefault();
if (!title.trim()) return; 

const payload = { theme, allowComments, visibility };
  if (title !== initialTitle) payload.title = title;
  if (description !== initialDescription) payload.description = description;

    setLoading(true);
    try {
    const res = await api.put(`${API_URL}/api/discussions/${discussion._id}`, payload);
    onUpdated({ ...discussion, ...res.data,
                allowComments: res.data.allowComments ?? discussion.allowComments });
    onClose();
  } catch (err) {
    console.error('Erreur update :', err);
    alert('Impossible de modifier la discussion');
  } finally {
    setLoading(false);
  }
  };



  return (
    <div className="modal-overlay">
      <div className="modal-card">

        <h2>{t('diffusion.update')}</h2>

        <label>{t('diffusion.name')}</label>
        <input
          className="modal-input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />


        <label>{t('diffusion.description')}</label>
        <textarea
          className="modal-textarea"
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />


        <label>{t('diffusion.theme')}</label>
        <select
          className="modal-input"
          value={theme}
          onChange={(e) => setTheme(e.target.value)}
        >
          {THEMES.map(k => <option key={k} value={k}>{t(`diffusion.${k}`)}</option>)}
        </select>

{/* ─── Autoriser les commentaires ─── */}
        <div style={{display: 'flex', gap: '5px'}}>
          <label>{t('diffusion.allowComments')}</label>
            <input
             type="checkbox"
              checked={allowComments}
              onChange={(e) => setAllowComments(e.target.checked)}
              
            />
         </div>   
   {/* ─── public ─── */}       
       <div className="form-group">
  <label>{t('diffusion.visibility')}</label>
  <select value={visibility} onChange={e => setVisibility(e.target.value)}>
    <option value="everyone">{t('diffusion.visibility_everyone')}</option>
    <option value="contacts">{t('diffusion.visibility_contacts')}</option>
  </select>
</div>


        <div className="modal-actions">
          <button onClick={onClose} className="btn-primary">{t('diffusion.annuler')}</button>
          <button onClick={handleSave} className="btn-primary">
            {t('diffusion.enregistrer')}
          </button>
        </div>


      </div>
    </div>
  );
}
